import { computed } from 'vue';
import { useSessionStore } from '@/shared/stores/sessionStore';
import { useLanguageStore } from '@/shared/stores/languageStore';
import { useTranslation } from '@/utils/locales/messages';
import { formatNotificationRelativeTime } from '@/utils/dateTimeUtils';

export function useInboxTimeFormat() {
  const sessionStore = useSessionStore();
  const languageStore = useLanguageStore();
  const { createSyncT } = useTranslation();
  const t = computed(() => createSyncT(languageStore.currentLanguage));

  const jurisdiction = computed(
    () => sessionStore.user?.customer?.jurisdiction || 'SG',
  );

  function tr(key: string, params?: Record<string, string | number>): string {
    let text = t.value(key) || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
      });
    }
    return text;
  }

  function formatTime(iso?: string | null): string {
    return formatNotificationRelativeTime(iso, jurisdiction.value, {
      justNow: () => tr('common.inbox.justNow'),
      minutesAgo: (count) => tr('common.inbox.minutesAgo', { count }),
      hoursAgo: (count) => tr('common.inbox.hoursAgo', { count }),
      daysAgo: (count) => tr('common.inbox.daysAgo', { count }),
    });
  }

  return { formatTime, jurisdiction };
}
